<div class="badge{{type ? ' -type-'+type : ''}}{{size ? ' -size-'+size : ''}}"
    [ngClass]="{'is-disabled': disabled, '-inverted': inverted, 'is-animating': isAnimating}">
    <ng-content></ng-content>
</div>
